import React, { useState, useEffect } from 'react';
import { actionsType } from 'config/constants';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import FilterService from 'services/Filter/';
import Metas from 'components/Metas';
import PubSub from "services/PubSub/";
import CatalogService from 'services/Catalog';
import CatalogContainer from 'components/Catalog';
import TagManagerService from "services/TagManager";
import { searchPagesRedirect } from 'config/index'
import style from './style.scss';//NOSONAR
import RenderService from 'services/Render'

let _isMounted = false;
let filterService = null;
let categoriesParams = null;
let categories = [];
let category = null;
let filters = null;
let specifications = [];
let location = null;
let filterByBrand = false;
let urlDecode = {};
let actions = [];

const getInitialState = (location) => {
    const data = RenderService.getRenderData();

    if(!(data && data.plp && data.plp.filters)){
        return {};
    }

    let search = '';

    if(location.search && location.search.indexOf('?ft=') !== -1){
        search = location.search.replace('?ft=', '').split('&')[0];
    }

    return {
        filters: true,
        search
    };
}

const Catalog = (props) => {
    const initialState = getInitialState(props.location);
    const [isLoaded, setIsLoaded] = useState(initialState.filters || false);
    const [searchTerm, setSearchTerm] = useState(initialState.search || '');

    useEffect(() => {
        _isMounted = true;
        _changeProps(props);

        getContent();

        return () => {
            _isMounted = false;
        };
    }, []);

    useEffect(()=> {
        actions.push(PubSub.register('catalog_empty', () => redirectError404()));
        actions.push(PubSub.register(actionsType.CATALOG_CHANGE_PROPS, _catalogChangeProps))
        actions.push(PubSub.register(actionsType.CATALOG_URL_REDIRECT, catalogUrlRedirect))
        actions.push(PubSub.register(actionsType.SET_SALES_CHANNEL, () => getContent()));

        return () => {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    });

    useEffect(() => {
        const pathname = props.location.pathname;
        const search = props.location.search;
        const prevPathname = location.pathname;
        const prevSearch = location.search;
        const searchParsed = queryString.parse(search);
        const prevSearchParsed = queryString.parse(prevSearch);

        if (pathname !== prevPathname || (prevSearch !== '' && search === '') || (searchParsed.ft && searchParsed.ft !== prevSearchParsed.ft) || (searchParsed.b && searchParsed.b !== prevSearchParsed.b) || (search !== prevSearch)) {
            _changeProps(props);

            getContent();
        }

        location = props.location;
    }, [props.location]);

    const _catalogChangeProps = (payload) => {
        if(!payload.value) return false;
        _changeProps(payload.value)
    }

    const _changeProps = (newProps) => {
        location = newProps.location;
        filterService = new FilterService(newProps);
        categoriesParams = filterService.categories;
    };

    const getContent = () => {
        if(isLoaded){
            setIsLoaded(false);
        }
        const {search} = props.location;
        const treatmentSeach = search.replace('?ft=', '');

        if(searchPagesRedirect[(treatmentSeach)]){
            TagManagerService.interaction(treatmentSeach, searchPagesRedirect[treatmentSeach], 'Redirect SearchBox')
            props.history.replace(searchPagesRedirect[treatmentSeach]);
            return false;
        }

        CatalogService.getFilters(filterService, categoriesParams, props.location, props.history).then(data => {
            if(!data){
                if (_isMounted) {
                    setIsLoaded(true);
                }
                return false;
            }

            setSearchTerm(data.searchTerm);
            filterByBrand = data.filterByBrand;
            filters = data.filters;
            categories = data.categories;
            specifications = data.specifications;
            category = data.category;
            urlDecode = {
                pathname: data.pathname,
                search: data.search
            }

            if(categories.length > 0){
                filters.categories = categories.slice(-1);
            } else if(filters.categories && filters.categories.length > 1){
                filters.categories = [
                    {
                        id: 0,
                        items: filters.categories,
                        name: 'Departaments',
                        url: '',
                        key: 'category-0'
                    }
                ];
            }

            if (_isMounted) {
                setIsLoaded(true);
            }
        });
    }

    const redirectError404 = (search = null) => {
        search = search ? `?ft=${search}` : '';
        props.history.push(`/Sistema/busquedavacia${search}`);
    }

    const catalogUrlRedirect = (payload) => {
        if(!(payload.value && payload.value.url)) return false;

        const {url, replace} = payload.value;

        if(replace) {
            props.history.replace(url);
        } else {
            props.history.push(url);
        }

    }

    const getTitle = () => {
        if(initialState.search) return "Búsqueda: " + initialState.search;
        if(!filterService) return '';
        const { search, collections } = filterService;
        if (search !== '' || collections !== '') {
            return  "Búsqueda: " + search;
        } else if(filterByBrand){
            return filters ? filters.brands.map(brand => brand.Name).join(', ') : '';
        } else {
            if(typeof category !== 'string'){
                return category ? category.name : "";
            }else{
                return category.replace(/-/g, ' ');
            }
        }
    }

    const title = getTitle();
    const title_path = props.location.pathname.replace('/', '').replace('_', ' ');
    const title_crumbs = title_path.charAt(0).toUpperCase() + title_path.slice(1).replace(/-/g, " ");
    const sideFilters = filterByBrand && filters ? {...filters, brands: []} :  filters;

    return (
        <div className="catalog-page page">
            {isLoaded && <Metas>
                <title>{title_crumbs.replace(/-/g, " ")} | Jumbo.cl</title>
                <meta name="description" content={"Encuentra la mejor variedad de productos de " + title_crumbs.replace(/-/g, " ") + " en jumbo.cl"} />
                <meta name="Abstract" content={"Encuentra la mejor variedad de productos de " + title_crumbs.replace(/-/g, " ") + " en jumbo.cl"} />
            </Metas>}
            {isLoaded && <CatalogContainer
                searchTerm={searchTerm}
                categories={categories}
                isLoaded={isLoaded}
                sideFilters={sideFilters}
                filters={filters}
                filterByBrand={filterByBrand}
                filterService={filterService}
                location={urlDecode}
                specifications={specifications}
                title={title || title_crumbs}
            />}
        </div>
    )
}

Catalog.propTypes = {
    history: PropTypes.object,
    location: PropTypes.object
};

export default Catalog;
